/* global OfficeRuntime */
export type ClientProps = {
  baseUrl: string;
};
export class Client {
  private _baseUrL: string;

  constructor({ baseUrl }: ClientProps) {
    this._baseUrL = baseUrl;
  }

  private getToken() {
    return OfficeRuntime.auth.getAccessToken({
      allowSignInPrompt: true,
      allowConsentPrompt: true,
    });
  }

  private setParams(url: URL, params?: URLSearchParams) {
    if (params) {
      for (const p of Array.from(params.entries())) {
        url.searchParams.append(p[0], p[1]);
      }
    }
    return url;
  }

  protected async get(path: string, params?: URLSearchParams) {
    const url = new URL(this._baseUrL + path || "");
    this.setParams(url, params);
    return fetch(url, { method: "GET", headers: { Authorization: `Bearer ${await this.getToken()}` } });
  }

  protected async post(path: string, data: object) {
    return fetch(this._baseUrL + path || "", {
      method: "POST",
      body: JSON.stringify(data),
      headers: { Authorization: `Bearer ${await this.getToken()}` },
    });
  }

  protected async unwrap<T>(response: Response) {
    if (response.ok) {
      return (await response.json()) as T;
    } else {
      let message = "ukjent feil";
      try {
        message = (await response.json())?.error || "ukjent feil";
      } catch (e) {
        //
      }
      throw Error(`(${response.status}) - ${message}`);
    }
  }
}
